import { Component, OnInit, Input } from '@angular/core';
import { URLSearchParams } from '@angular/http';

import { AuthService } from '../../../../../providers/auth.service';
import { SharedHackService } from '../../../shared/services/shared-hack.service';
import { ScreenTalentService } from '../../screen-talent.service';


export class PendingComponent implements OnInit {
	 public test: any;

	public candidates: any[];
	public offset = 0;
	public size = 10;
	public state: any = {
		loading: false,
		hasMore: true,
		count: 0
	};

	constructor(
		private authService: AuthService,
		private sharedHackService: SharedHackService,
		private screenTalentService: ScreenTalentService) { }

	// Lifecycle Events
	public ngOnInit(): void {
		this.getCandidatesCount();
		this.getCandidates();
	}

	// Service Call
	private getCandidatesCount(): void {
		let queryParams = new URLSearchParams();
		queryParams.append('statuses[]', 'pending');
		queryParams.append('statuses[]', 'started');

		this.sharedHackService.getExternalTestInvitationsCount(String(this.authService.userId), this.test.id, queryParams).subscribe(
			(stats) => {
				this.state.count = stats.total;
				this.screenTalentService.emitEventAction({ component: 'screen-talent', action: 'updatePendingCandidatesCount', data: this.state.count });
			}
		);
	}

	private getCandidates(): void {
		this.state.loading = true;

		let queryParams = new URLSearchParams();
		queryParams.append('statuses[]', 'pending');
		queryParams.append('statuses[]', 'started');
		queryParams.set('limit', String(this.size));
		queryParams.set('offset', String(this.offset));

		this.sharedHackService.getExternalTestInvitations(String(this.authService.userId), this.test.id, queryParams).subscribe(
			(candidates) => {
				this.candidates = this.candidates || [];
				this.candidates = this.candidates.concat(candidates);
				this.state.hasMore = candidates.length === this.size ? true : false;

				this.state.loading = false;
			}
		);
	}

	// Helpers

	private onLoadMoreClick(): void {
		this.offset += this.size;
		this.getCandidates();
	}
static ctorParameters() { return [ { type: AuthService }, { type: SharedHackService }, { type: ScreenTalentService } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/screen-talent/test/pending/pending.component.ts